module.exports = __webpack_public_path__ + "assets/img/one-tab7-on.5e37106d.png";